import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { ROLE_TYPES } from '../../utils/DataConstants';
import OverviewShell from '../overview_shell/OverviewShell';
import { withUserType } from '../withUserType';

// Suppliers is the only tab that works today; Assets (both roles) and Parts (supplier only) are shown
// disabled until the backend can materialize those entity types.
const SUPPLIERS_TAB = { key: 'suppliers', name: 'Suppliers' };
const ASSETS_TAB = { key: 'assets', name: 'Assets', disabled: true };
const PARTS_TAB = { key: 'parts', name: 'Parts', disabled: true };

const RequestsToAddOverviewPage: FC<any> = ({
	history,
	childRoutes,
	userType,
}): React.ReactElement => {
	const tabs = useMemo(
		() =>
			userType === ROLE_TYPES.SUPPLIER
				? [SUPPLIERS_TAB, ASSETS_TAB, PARTS_TAB]
				: [SUPPLIERS_TAB, ASSETS_TAB],
		[userType]
	);

	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/requestsToAdd/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => history.location.pathname.indexOf(key) !== -1,
		[history.location.pathname]
	);

	return (
		<>
			<Route
				path={`/${userType}/requestsToAdd/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/requestsToAdd/overview/suppliers`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Suggested Entities"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="requestsToAddPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withUserType(
	withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(RequestsToAddOverviewPage))
);
